import { Database } from "../../supabase.types";
import { UserSubscriptionTiersByComedianId } from "../../models/subscriptions";
import { getApiClient } from "@punchup/utils/apiRegistry";

export type UserPaidSubscriptionRow =
  Database["public"]["Tables"]["user_paid_subscriptions"]["Row"];

export async function getUserPaidSubscriptions(params?: {
  active?: boolean;
  comedianId?: string;
}): Promise<UserPaidSubscriptionRow[]> {
  const searchParams = new URLSearchParams();
  if (params?.active !== undefined) {
    searchParams.append("active", params.active.toString());
  }
  if (params?.comedianId) {
    searchParams.append("comedian_id", params.comedianId);
  }
  const qs = searchParams.toString();
  const response = await getApiClient().get<{
    data: UserPaidSubscriptionRow[];
  }>(`/api/v2/user/paid-subscriptions${qs ? `?${qs}` : ""}`);
  return response.data;
}

/**
 * Cancels the user's paid subscription. The subscription stays active until the
 * end of the current billing period (`valid_until`); the user keeps their free
 * follow.
 */
export async function cancelUserPaidSubscription(
  subscriptionId: string
): Promise<void> {
  await getApiClient().del(`/api/v2/user/paid-subscriptions/${subscriptionId}`);
}

export async function getUserPaidSubscriptionTiers(): Promise<UserSubscriptionTiersByComedianId> {
  const response = await getApiClient().get<{
    data: UserSubscriptionTiersByComedianId;
  }>("/api/v2/user/paid-subscription-tiers");
  return response.data;
}
